import logo from '../logo.svg';
import hostages from '../res/134.svg';
import logoNight from '../logo_night.svg';
import '../App.css';
import { useTranslation } from 'react-i18next';
import { React, useContext } from 'react';
import External from './Extrenal';
import {useCurrentUser} from "../helpers/UserContext";
import {useConfig} from "../helpers/useConfig";
import Btn from './Button';



function AppExternal({json, cssClasses, src}) {
  
  const { t, i18n } = useTranslation();
  const { currentUser, fetchCurrentUser } = useCurrentUser();
  const {configData, setConfig} = useConfig();
 
  const current = json.jws.current;
  function isNight() {
    return cssClasses.includes("night");   
    
  } 
  var logoToDisplay = isNight() ? logoNight : logo; 
  var langcode = configData.lang;
  if (json.length === 0){ 
    return <div>loading...</div>
  }
  
  if (json.length === 0){ 
    return <div>loading...</div>
  }
    return (
      <>
      <div className={"clouds container-fluid App " + cssClasses}> 
      <header className={"App-header row mb-2 " + (langcode === 1? 'rtl' : '')}>
      <div className="row ">
        
          <div className="col-12 ">
          <div className="AppHeader">
          <div className="App-logo-container"><a href={`/`}> <img src={logoToDisplay} className="App-logo" alt="logo"/></a></div>
                           {t("SLOGAN")}{" "}
                          - {t("WEBSITE_TITLE")}<div className="App-date"> {eval(`current.date${langcode}`)} </div>
          </div>
          </div>
      </div>
      <div className="row ">
      <div className="col-4 ">
            
        </div>
        <div className="col-4 ">

        </div>
        <div className="col-4 ">

        </div>
      </div>
      
       </header>
       <div className={"row "  + (langcode === 1? 'rtl' : '')}>
       <div className="col-12 bg-light p-1 border"><External src={src} width="100%" height="900" className={cssClasses}/></div>
       </div> 
       
     </div>
     </>
    );
  
}

export default AppExternal;
